// @flow

import { type Receipt } from '../types';
import { type Fx } from '@tectonics/prs/money';

export function getFx(receipt: Receipt): Fx {
  return receipt['fx'];
}
